export default __webpack_public_path__ + "static/media/1.d3e99ab3.svg";